import { normalize } from 'normalizr';
import { query } from '@/dex-shared/helpers/graphql';
import { question } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_SEARCH_RESULTS({ commit }: any, searchTerm: string) {
    let searchSubjectsResponse = await query(
      `query($searchTerm: String!) {
        getSimilarQuestions(searchText: $searchTerm, hasMode: "essay", limit: 12) {
          id
          score
          questionInfo {
            id
            title
            mode
            slug
            createdAt
            examModeId
          }
        }
      }
      `,
      { searchTerm },
    );

    const { getSimilarQuestions } = searchSubjectsResponse.data;
    commit('SET_SUBJECT_SEARCH', getSimilarQuestions);

    if (getSimilarQuestions.length > 0) {
      let questions = getSimilarQuestions.map(
        elasticQuestion => elasticQuestion.questionInfo,
      );
      let normalizedResponse = normalize(questions, [question]);
      commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
    }
  },
};
